import BaseModel from './BaseModel';
import ApplicationModel from './ApplicationModel';
import CategoryResponseModel from '../../domains/applications/models/CategoryResponseModel';
import PlanModel from '../../domains/applications/models/PlanModel';
import ScopeResponseModel from '../../domains/applications/models/ScopeResponseModel';
import { WebhookResponse } from '@/domains/applications/types/create-app/createApp.enum';

class FullApplicationProgressResponseModel extends BaseModel {
  public payload: AppPayloadInterface | null;

  constructor(arg: any) {
    super(arg);
    this.payload = arg.payload;
  }
}

export interface AppPayloadInterface {
  app: ApplicationModel;
  categories?: CategoryResponseModel[];
  tags?: { id: number; slug: string; name: string }[];
  category: CategoryResponseModel;
  development: string | null; // check other types
  headScripts: [];
  isAppInDevelopmentStore: boolean;
  plans: PlanModel[];
  // Unsubmitted partner edits held on the BE. Entries may carry `id: null` for
  // net-new plans that don't yet exist in the live `plans` array.
  plans_draft?: PlanModel[];
  scopeGroups: ScopeResponseModel[];
  tokens: {
    id: number;
    secret: string;
  };
  webhooks: Record<string, WebhookResponse[]>;
  webhooksAvailable: string[];
  app_url: string;
  plans_update_status: UpdateStatusEnum;
  plans_last_review?: PlansLastReview | null;
  general_settings_update_status: UpdateStatusEnum;
  app_snippets: SnippetItemInterface[];
}

export enum UpdateStatusEnum {
  None = '',
  Processed = 'processed',
  Pending = 'pending',
  Rejected = 'rejected',
  Approved = 'approved',
}

/**
 * Shape the BE returns under `plans_last_review` (nullable on the payload).
 * `note` carries the reviewer's rejection reason; it can be null if the
 * reviewer didn't leave one, so the FE has to fall back to a generic message.
 */
export interface PlansLastReview {
  status: UpdateStatusEnum;
  note: string | null;
  reviewed_at: string;
  submitted_at: string;
}

export enum AppSnippetLocationEnum {
  Head = 'head',
  Body = 'body',
  PurchaseEvent = 'purchase_event',
  CheckoutEvent = 'start_checkout_event',
  AddToCartEvent = 'add_to_cart_event',
  RemoveFromCartEvent = 'remove_from_cart_event',
  ProductDetailsEvent = 'product_details_event',
}

export enum AppSnippetLocationLabelEnum {
  Head = 'Before </head>',
  Body = 'Before </body>',
  PurchaseEvent = 'Purchase Event',
  CheckoutEvent = 'Start Checkout Event',
  AddToCartEvent = 'Add To Cart Event',
  RemoveFromCartEvent = 'Remove From Cart Event',
  ProductDetailsEvent = 'Product Details Event',
}

export interface SnippetItemInterface {
  id: number;
  name: string;
  location: AppSnippetLocationEnum;
  snippet: string;
}

export default FullApplicationProgressResponseModel;
